import { IsISO8601WithTimezone } from '@agroone/helpers'
import { IsNotEmpty, IsNumber, IsOptional, IsString, Validate } from 'class-validator'

export class SaveForeignMaterial {
  @IsNumber()
  @IsOptional()
  id?: number

  @Validate(IsISO8601WithTimezone)
  @IsNotEmpty()
  targetDate!: string

  @IsString()
  @IsNotEmpty()
  type!: string

  @IsString()
  @IsOptional()
  subType?: string

  @IsString()
  @IsOptional()
  area?: string

  @IsString()
  @IsOptional()
  level?: string
}
